<template>
  <div class="text-button__wrapper">
    <router-link
      v-if="to"
      :to="to"
      class="text-button"
      :class="{ '-accent': accent, '-accent-g': accentG, '-small': small }"
    >
      {{ title }}
    </router-link>
    <button
      @click="click"
      v-if="!to"
      class="text-button"
      :class="{ '-accent': accent, '-accent-g': accentG, '-small': small }"
    >
      {{ title }}
    </button>
  </div>
</template>

<script>
export default {
  name: "TextButton",
  props: {
    title: {
      type: String,
      default: undefined,
      required: true
    },
    to: {
      type: String,
      default: undefined,
      required: false
    },
    accent: {
      type: Boolean,
      default: false
    },
    accentG: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click: function() {
      return this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
.text-button {
  background-color: transparent;
  border-radius: sizes("border-radius-s");
  border: 0;
  color: theme-color("body");
  cursor: pointer;
  display: block;
  font-size: px-to-rem(16px);
  padding: spacer("s");
  text-decoration: underline;
  transition: cta-transition(background-color, 0.2s);

  @include if-tablet {
    font-size: px-to-rem(20px);
  }

  &:hover {
    background: rgba(theme-color("black"), 0.05);
  }

  &.-accent {
    color: theme-color("accent-1");
    font-weight: 700;
  }

  &.-accent-g {
    color: darken(theme-color("inactive"), 5%);
    font-weight: 700;
  }

  &.-small {
    font-size: px-to-rem(13px);
    padding: spacer("xs");

    @include if-tablet {
      font-size: px-to-rem(14px);
    }
  }
}
</style>
